import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Hammer } from 'lucide-react';

export const Route = createFileRoute('/admin-console/tools')({
    staticData: {
        permissions: ['admin_system:read'],
        breadcrumb: {
            title: 'Tools',
            inactive: true,
        },
        ui: {
            icon: Hammer,
            title: 'Tools',
            menuDescription: 'Helpful utilities and tools',
        },
    },
    component: Outlet,
});
